export default __webpack_public_path__ + "static/media/up.cb68b2cb.svg";